<template>
  <div class="detail-page">
    <header class="detail-header">
      <div class="header-row">
        <div class="header-text">
          <p class="home-label">三高体检·内勤</p>
          <h1>客户问卷详情</h1>
        </div>
        <button class="back-button-sm" @click="goBack">返回</button>
      </div>
    </header>

    <main class="detail-body">
      <div v-if="loading" class="state-cell">
        <van-loading color="#168de0" size="22" vertical>加载中...</van-loading>
      </div>

      <template v-else-if="detail">
        <div class="detail-side">
        <section class="info-card">
          <div class="info-top">
            <span class="info-name">{{ detail.personName || "匿名用户" }}</span>
            <span class="audit-badge" :class="`audit-${detail.auditStatus}`">
              {{ auditText(detail.auditStatus) }}
            </span>
          </div>
          <div class="info-row"><span class="info-label">手机号</span><span>{{ detail.phone || "-" }}</span></div>
          <div class="info-row"><span class="info-label">性别</span><span>{{ detail.gender || "-" }}</span></div>
          <div class="info-row"><span class="info-label">年龄</span><span>{{ detail.age != null ? detail.age + "岁" : "-" }}</span></div>
          <div class="info-row"><span class="info-label">身份证</span><span>{{ maskIdCard(detail.idCard) }}</span></div>
          <div class="info-row"><span class="info-label">业务员</span><span>{{ detail.salesmanName || "-" }}</span></div>
          <div class="info-row"><span class="info-label">提交时间</span><span>{{ formatTime(detail.submitTime) }}</span></div>
          <div class="info-row"><span class="info-label">问卷</span><span>{{ questionnaireText }}</span></div>
          <div class="info-row"><span class="info-label">填写次数</span><span>{{ detail.revisionNo || "-" }}</span></div>
          <div class="info-row"><span class="info-label">初筛结果</span><span>{{ qualifiedText(detail) }}</span></div>
          <screening-review-notice :record="detail" />
        </section>

        <section v-if="!detail.screeningStatus && detail.flags && detail.flags.length" class="flag-card">
          <p class="flag-title">风险提示</p>
          <div class="flag-list">
            <span v-for="(flag, i) in detail.flags" :key="i" class="flag-tag">{{ flag }}</span>
          </div>
        </section>
        </div>

        <div class="detail-main">
          <section
            v-for="(group, gi) in answerGroups"
            :key="gi"
            class="answer-card"
          >
            <p class="answer-group-title">{{ group.title }}</p>
            <div
              v-for="(item, ii) in group.items"
              :key="ii"
              class="answer-row"
            >
              <div class="answer-label">
                <small v-if="item.groupTitle">{{ item.groupTitle }}</small>
                <p>{{ item.questionTitle }}</p>
              </div>
              <div class="answer-value">{{ item.displayValue || "—" }}</div>
            </div>
          </section>

          <div v-if="!answerGroups.length" class="state-cell">
            <van-icon name="records" size="32" color="#b4cad9" />
            <p>暂无问卷填写内容</p>
          </div>
        </div>
      </template>

      <div v-else class="state-cell">
        <van-icon name="warning-o" size="32" color="#b4cad9" />
        <p>{{ loadError || "未找到客户信息" }}</p>
      </div>
    </main>
  </div>
</template>

<script>
import { Toast } from "vant";
import { qualifiedText } from "./pc/customer-data";
import ScreeningReviewNotice from './screening-review-notice.vue';
import { getSanGaoStaffCustomerDetail } from "@/api/sanGaoStaff";

export default {
  name: "SanGaoStaffCustomerDetail",
  components: { ScreeningReviewNotice },
  data() {
    return {
      loading: true,
      detail: null,
      loadError: "",
    };
  },
  computed: {
    answerGroups() {
      const groups = [];
      const groupMap = {};
      (this.detail && this.detail.answerItems ? this.detail.answerItems : []).forEach((item) => {
        const title = item.sectionTitle || "问卷填写内容";
        if (!groupMap[title]) {
          groupMap[title] = { title, items: [] };
          groups.push(groupMap[title]);
        }
        groupMap[title].items.push(item);
      });
      return groups;
    },
    questionnaireText() {
      if (!this.detail) return "-";
      const name = this.detail.questionnaireName || "问卷";
      const version = this.detail.questionnaireVersion ? `（版本${this.detail.questionnaireVersion}）` : "";
      const disease = this.diseaseText(this.detail.disease);
      return `${name}${version}${disease ? ` · ${disease}` : ""}`;
    },
  },
  created() {
    this.loadDetail();
  },
  methods: {
    qualifiedText,
    async loadDetail() {
      const customerId = this.$route.query.customerId;
      if (!customerId) {
        this.loadError = "缺少客户参数";
        this.loading = false;
        return;
      }
      this.loading = true;
      try {
        const res = await getSanGaoStaffCustomerDetail({ customerId });
        if (res && res.code === 200 && res.data) {
          this.detail = res.data;
        } else {
          this.loadError = (res && res.msg) || "未找到客户信息";
        }
      } catch (e) {
        this.loadError = "网络异常，请稍后重试";
        Toast(this.loadError);
      } finally {
        this.loading = false;
      }
    },
    diseaseText(disease) {
      if (!disease) return "";
      if (disease === "hypertension") return "高血压";
      if (disease === "diabetes") return "糖尿病";
      if (disease === "uric") return "高尿酸";
      return disease;
    },
    auditText(status) {
      if (status === 0) return "待审核";
      if (status === 1) return "已通过";
      if (status === 2) return "已驳回";
      if (status === 3) return "已支付";
      if (status === 4) return "已退款";
      return "-";
    },
    maskIdCard(idCard) {
      if (!idCard) return "-";
      if (idCard.includes("*")) return idCard;
      if (idCard.length === 18) return `${idCard.slice(0, 6)}********${idCard.slice(-4)}`;
      if (idCard.length === 15) return `${idCard.slice(0, 4)}********${idCard.slice(-3)}`;
      return "****";
    },
    formatTime(value) {
      if (!value) return "-";
      const d = new Date(value);
      if (isNaN(d.getTime())) return "-";
      const pad = (n) => (n < 10 ? `0${n}` : String(n));
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    goBack() {
      this.$router.replace("/sanGao/staff/index");
    },
  },
};
</script>

<style lang="less" scoped>
.detail-page {
  position: relative;
  min-height: 100vh;
  padding: 0 0 32px;
  background: linear-gradient(180deg, #0874ca 0%, #4ba8e0 22%, #dff6ff 48%, #f4fafd 100%);
  color: #163b5c;
}

.detail-header {
  padding: 22px 18px 16px;
  color: #fff;
  text-shadow: 0 2px 8px rgba(0, 48, 113, 0.35);
}

.header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-text {
  flex: 1;
  min-width: 0;
}

.home-label {
  margin: 0 0 6px;
  font-size: 11px;
  letter-spacing: 2px;
  opacity: 0.9;
}

.detail-header h1 {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
}

.back-button-sm {
  height: 28px;
  padding: 0 12px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 14px;
  font-size: 12px;
  color: #fff;
  background: transparent;
  cursor: pointer;
}

.detail-body {
  padding: 0 16px;
}

.info-card,
.flag-card,
.answer-card {
  margin-bottom: 14px;
  padding: 14px 16px;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 6px 16px rgba(12, 91, 147, 0.08);
}

.info-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.info-name {
  font-size: 16px;
  font-weight: 700;
  color: #163b5c;
}

.audit-badge {
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
}

.audit-0 {
  color: #b6820b;
  background: #fff5d6;
}

.audit-1 {
  color: #1b8a4b;
  background: #dff7e8;
}

.audit-2 {
  color: #b14545;
  background: #fde0e0;
}

.audit-3 {
  color: #1670c0;
  background: #ddf0fd;
}

.audit-4 {
  color: #8a63c9;
  background: #efe6fc;
}

.info-row {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  font-size: 13px;
  color: #4a6a82;
}

.info-label {
  flex-shrink: 0;
  margin-right: 16px;
  color: #93a8b8;
}

.flag-title,
.answer-group-title {
  margin: 0 0 10px;
  font-size: 14px;
  font-weight: 600;
  color: #163b5c;
}

.flag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.flag-tag {
  padding: 3px 10px;
  border-radius: 10px;
  font-size: 11px;
  color: #b6820b;
  background: #fff5d6;
}

.answer-row {
  display: flex;
  flex-direction: column;
  padding: 9px 0;
  border-bottom: 1px solid #eef4f9;
}

.answer-row:last-child {
  border-bottom: 0;
}

.answer-label {
  margin-right: 16px;
}

.answer-label small {
  display: block;
  font-size: 10px;
  color: #93a8b8;
}

.answer-label p {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #4a6a82;
  word-break: break-all;
}

.answer-value {
  margin-top: 4px;
  font-size: 13px;
  font-weight: 600;
  text-align: left;
  word-break: break-all;
  color: #163b5c;
}

.state-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 0;
  color: #7c8d9c;
}

.state-cell p {
  margin: 8px 0 0;
  font-size: 12px;
}
</style>
